import { assertNonNullable } from '@disy/lib/custom-error';

export function resolveReference<T>(styles: T[], reference: string): T {
  const index = resolveReferenceToIndex(reference);
  return styles[index];
}

const NUMBER_REG_EXP = /\d+/g;

function resolveReferenceToIndex(reference: string) {
  // This is a shortcut to not having to respect the whole JSON Reference spec
  // from: https://tools.ietf.org/id/draft-pbryan-zyp-json-ref-03.html
  // It assumes that the given reference has the pattern "#/styles[123]".
  const match = reference.match(NUMBER_REG_EXP);
  assertNonNullable(match);
  return match.map(Number)[0];
}
